import React from "react";
import { Helmet } from "react-helmet";
import { LazyLoadImage } from "react-lazy-load-image-component";
import MultiLingualContent from "../../../languages/MultiLingualContent";
import afarkasit1 from "../../../assets/images/afarkasit1.jpeg";
import afarkasit2 from "../../../assets/images/afarkasit2.jpeg";
import BackButton from "../../backButton";

const Afarkasit = () => {
  return (
    <div className="inner-section" id="afarkasit">
      <Helmet>
        <title>פטרידע - הפטריה אפרכסית</title>
        <meta
          name="description"
          content="הפטריה אפרכסית - Panus: תאור, זיהוי ותמונות"
        />
      </Helmet>
      <BackButton path="/#types-and-species" />
      <h2>
        <MultiLingualContent contentID="afarkasit" />
      </h2>
      <>
        <div className="informationText">
          <p>
            <MultiLingualContent contentID="afarkasitText1" />
          </p>
          <p>
            <MultiLingualContent contentID="afarkasitText2" />
          </p>
          <br />
          <p>
            <b>
              <MultiLingualContent contentID="afarkasitText3Bold" />
            </b>
          </p>
          <p>
            <MultiLingualContent contentID="afarkasitText4" />
          </p>
          <p>
            <MultiLingualContent contentID="afarkasitText5" />
          </p>
        </div>
        <div className="informationImages">
          <div className="imgWrapper">
            <LazyLoadImage src={afarkasit1} alt="אפרכסית" />
            <p>
              <MultiLingualContent contentID="afarkasitImg1" />
            </p>
          </div>
          <div className="imgWrapper">
            <LazyLoadImage src={afarkasit2} alt="אפרכסית" />
            <p>
              <MultiLingualContent contentID="afarkasitImg2" />
            </p>
          </div>
        </div>
      </>
    </div>
  );
};

export default Afarkasit;
